import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import JiriWebView from '@/modules/jiri/JiriWebView'
import { Stack, useLocalSearchParams } from 'expo-router'

export default function JiriPage() {
  const { conversationId } = useLocalSearchParams<{ conversationId?: string }>()
  const headerLeftItems = useWebBackButton('/forms')

  return (
    <>
      {/* Mobile web keeps the 返回 every other page there has, top left where a phone reader looks for the way
          back. jiri-web also draws a close button because it is framed; that one goes back too. */}
      <Stack.Screen options={buildScreenHeaderItems({ left: headerLeftItems })} />
      <JiriWebView conversationId={conversationId || undefined} />
    </>
  )
}
